"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEachObjectEntry = void 0;
var tslib_1 = require("tslib");
function forEachObjectEntry(obj, fn) {
    Object.entries(obj).forEach(function (_a) {
        var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
        return fn(value, key);
    });
}
exports.forEachObjectEntry = forEachObjectEntry;
//# sourceMappingURL=forEachObjectEntry.js.map